import { ReportStatus } from "@/types/evaluate";

export const getProgressPercentage = (reportStatus?: ReportStatus) => {
  if (!reportStatus) {
    return 0;
  }

  const total =
    reportStatus.COMPLETED +
    reportStatus.FAILED +
    reportStatus.RUNNING +
    reportStatus.QUEUED;

  if (total === 0 || reportStatus.COMPLETED + reportStatus.FAILED === 0) {
    return 0;
  }

  // Calculate the percentage using the original logic
  let percentage = Math.floor(
    ((reportStatus.QUEUED + reportStatus.RUNNING > 0
      ? reportStatus.COMPLETED + reportStatus.FAILED
      : reportStatus.COMPLETED) /
      total) *
      100,
  );

  // If there are still items queued or running, cap at 99%
  if (reportStatus.QUEUED + reportStatus.RUNNING > 0 && percentage === 100) {
    percentage = 99;
  }

  return percentage;
};
